import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Box from '../Box';
import useMenuItem from './useMenuItem';

const MenuLink = forwardRef(({
  children,
  active,
  highlighted,
  iconBefore,
  iconAfter,
  onClick,
  style, // don't forward
  className, // don't forward
  ...rest
}: any, ref?: any) => {
  const {
    classNames,
    IconBefore,
    IconAfter,
    Content,
  } = useMenuItem({
    active,
    highlighted,
    iconBefore,
    iconAfter,
  });

  return (
    <Box
      element="a"
      display="flex"
      alignItems="center"
      className={classNames}
      {...rest}
      innerRef={ref}
      onClick={(...args: any[]) => {
        if (typeof onClick === 'function') onClick(...args);
      }}
    >
      <IconBefore />
      <Content>
        { children }
      </Content>
      <IconAfter />
    </Box>
  );
}) as any;

(MenuLink as any).propTypes = {
  /**
    * The text for this menu item
    */
  children: PropTypes.node.isRequired,
  /**
    * Where to link to
    */
  href: PropTypes.string,
  /**
    * Whether or not to display this item as active
    */
  active: PropTypes.bool,
  /**
    * An <Icon /> to show on the right of the item
    */
  iconAfter: PropTypes.node,
  /**
    * An <Icon /> to show on the left of the item
    */
  iconBefore: PropTypes.node,
};

(MenuLink as any).defaultProps = {};

(MenuLink as any).displayName = 'MenuLink';

export default MenuLink;
